<bn-loading-overlay></bn-loading-overlay>
<div class="mb-3">
  <div class="row">
    <h4>Consulta de valores de limite de exposição do fundo</h4><br>
  </div>
  <div class="row justify-content-end">
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="abrirModalImportarValorExposicaoSetor()"
        *ngIf="podeImportarArquivo && !ehFGBS" placement="top"
        ngbTooltip="Realiza a importação dos valores comprometidos na Exposição por Setor, no Fundo do Portal FGI (sistema legado)">
        <i class="fa fa-file"></i> Importar Legado Limite Exposição por Setor</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="abrirModal()" *ngIf="podeImportarArquivo && !ehFGBS"
        placement="top"
        ngbTooltip="Realiza a importação dos valores de exposição existentes no Fundo no Portal FGI (sistema legado)">
        <i class="fa fa-file"></i> Importar Legado limite por Agente Financeiro
      </button>
    </div>
  </div>
  <div class="row">
    <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
  </div>
</div>
<div *ngIf="!ehFGBS" class="row">
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Limite</th>
          <th class="titulo-moeda">Patrimônio liquido</th>
          <th class="titulo-moeda">Limite exposição</th>
          <th class="titulo-moeda">Exposição atual</th>
          <th class="text-end" container="body"
            ngbTooltip="Total do valor exposto do Fundo no Portal FGI (sistema legado) para todos os Agentes Financeiros que operaram">
            Exposição Legado</th>
          <th class="titulo-moeda">Valor disponível</th>
        <tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Global
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorPatrimonioLiquido | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorLimiteExposicao | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorExposicaoAtual | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorLimiteLegado | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorDisponivel | bnMask:'MOEDA' }}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span ngbTooltip="Exposição por setor para CNAES permitidos grandes empresas">Exposição por Setor</span>
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorLimiteExposicaoGrandesEmpresas | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorExposicaoAtualGrandesEmpresas | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorLimiteLegadoExposicaoGrandesEmpresas | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteDto?.valorDisponivelGrandesEmpresas | bnMask:'MOEDA' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="ehFGBS" class="row">
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Data base</th>
          <th>Patrimônio liquido do fundo</th>
        <tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{ limiteDto?.dataBase | date: (ehFGBS ? 'dd/MM/yyyy': 'MM/yyyy') }}
          </td>
          <td>
            {{ limiteDto?.valorPatrimonioLiquido | bnMask:'MOEDA' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="ehFGBS" class="letra-miuda">* O valor de limite total de exposição está limitado ao valor disponível do limite de contratação do fundo.</div>

<br>

<h5>Limite por agente financeiro</h5>

<div class="container">
  <div class="mb-3 row">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-light align-self-end" [disabled]="!podeImportarArquivo"
        (click)="limparPesquisa()">Limpar</button>

      <button type="button" class="btn btn-success align-self-end" style="margin-left: 20px;"
        [disabled]="!podeImportarArquivo" (click)="buscar()">Pesquisar</button>
    </div>
  </div>

  <div class="bn-form-group row">
    <div class="bn-form-group col-md-8">
      <label for="agenteFinanceiro">Agente Financeiro:</label>
      <ng-select [(ngModel)]="agenteFinanceiroSelect" id="agenteFinanceiro" [items]="agentesFinanceiros"
        bindLabel="nome" placeholder="Todos" class="auto-grow" [readonly]="cnpjUsuario" [disabled]="cnpjUsuario"
        [ngClass]="{'disabled-ng-select' : cnpjUsuario}">
        <ng-template ng-label-tmp let-item="item">
          {{ item.nome + ' (' + item.cnpj + ')' }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" container="body">
          {{ item.nome + ' (' + item.cnpj + ')' }}
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>

<ng-template #bodyExposicaoSetor>
  <form>
    <div class="row">

       <div class="col-sm-4">
          Deseja realizar a importação:
       </div>
      <div class="col-sm-2">
        <input type="radio" value="manual" name="opcaoEnvio" (change) ="validarOpcaoImportacao($event.target.value)"> Manual
      </div>
      <div class="col-sm-2">
        <input type="radio" value="porArquivo" name="opcaoEnvio" (change) ="validarOpcaoImportacao($event.target.value)"> Por Arquivo
      </div>
      <br><br>
 </div>
    <div class="row" *ngIf="!opcaoExposicaoSetorEnvioArquivo">
      <div class="bn-form-group align-self-center col-sm-5">
        <b><label class="form-label">Valor a ser importado para Exposição por Setor:</label></b>
      </div>

      <div class="bn-form-group col-sm-4">
        <input type="text" id="valorImportadoExposicaoSetor" name="valorImportadoExposicaoSetor" class="form-control"
          bnMask="MOEDA" [(ngModel)]="valorImportadoExposicaoSetor">
      </div>
      <br />
    </div>
   <div class="row" *ngIf="opcaoExposicaoSetorEnvioArquivo">
    <div class="bn-form-group align-self-center col-sm-3">
      <label class="form-label"> Arquivo a ser importado:</label>
    </div>

    <div class="bn-form-group col-sm-6">
      <bn-file-uploader #uploaderArquivoExposicaoSetorSistemaLegado [autoUpload]="false" [form]="true" [tipoPermitido]="'.csv'"
        [quantidadeArquivosPorLinha]="1" [tamanhoMaximo]="40" [descricao]="false" [numeroMaximoArquivos]="1"
        ngbTooltip="Anexar até 01 arquivo com no máximo 40Mbytes" placement="left" [edicao]="true">
      </bn-file-uploader>
    </div>
    <br />
  </div>



  </form>
</ng-template>


<ng-template #botoesExposicaoSetor>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-primary" (click)="importarValorExposicaoSetor()">Importar</button>
</ng-template>



<ng-template #body>
  <form>
    <div class="row">
      <div class="bn-form-group align-self-center col-sm-3">
        <label class="form-label"> Arquivo a ser importado:</label>
      </div>

      <div class="bn-form-group col-sm-6">
        <bn-file-uploader #uploaderArquivoSistemaLegado [autoUpload]="false" [form]="true" [tipoPermitido]="'.csv'"
          [quantidadeArquivosPorLinha]="1" [tamanhoMaximo]="40" [descricao]="false" [numeroMaximoArquivos]="1"
          ngbTooltip="Anexar até 01 arquivo com no máximo 40Mbytes" placement="left" [edicao]="true">
        </bn-file-uploader>
      </div>
      <br />
    </div>
  </form>
</ng-template>


<ng-template #botoes>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-primary" (click)="importarArquivoLegado()">Importar</button>
</ng-template>


<app-limite-exposicao-listagem [ehFGBS]="ehFGBS" [agenteFinanceiro]="agenteFinanceiroSelect" [limites]="limites"
  [dataHoraResultado]="dataHoraResultado" [msgSemResultado]="msgSemResultado" (exportarLista)="exportarLista()">
</app-limite-exposicao-listagem>